/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/jsx-no-useless-fragment */
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Form,
  FormField,
  FormItem,
  FormControl,
  DatePicker,
  Input,
} from "@repo/ui";
import { useNavigate } from "react-router-dom";
import { ExcelRenderer } from "react-excel-renderer";
import { useEffect, useState } from "react";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import sweetAlert from "components/sweet-alert";
import { Label } from "ui/label";
import { useUploadUnderReplenishmentSite } from "services/tickets";
import Loader from "ui/page-loader";

export default function SiteReplenishmentTickets() {
  const [replenishmentSites, setReplenishmentSites] = useState([]);
  const navigate = useNavigate();
  const replenishmentSitesForm = useForm({
    defaultValues: { serviceDate: null, file: null },
  });

  const {
    mutate: uploadReplenishmentSite,
    data: uploadReplenishmentSiteRes,
    isPending: uploadingReplenishmentSite,
  } = useUploadUnderReplenishmentSite();
  useEffect(() => {
    if (uploadReplenishmentSiteRes) {
      navigate(-1);
    }
  }, [uploadReplenishmentSiteRes]);

  const onSaveUploadReplenishmentSite = (data) => {
    const payload = { operationDate: data.serviceDate, sites: [] };
    let isDataValid = true;
    for (let i = 0; i < replenishmentSites.length; i++) {
      const item = replenishmentSites[i];
      if (!item.AssetId) {
        sweetAlert({
          title: "Invalid Data",
          text: "Required Fields Are Missing In List",
          icon: "error",
        });
        isDataValid = false;
        break;
      }
      if (!isDataValid) {
        return;
      }
      payload.sites.push({
        assetId: `${item.AssetId}`,
        underReplenishment: item.UnderReplenishment,
      });
    }

    sweetAlert({
      title: "Operation Confirmation",
      text: `Are you sure?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Confirm",
      cancelButtonText: "Cancel",
      onConfirm: () => {
        uploadReplenishmentSite(payload);
      },
    });
  };

  const uploadReplenishmentSiteFileHandler = (event, field) => {
    if (event?.target?.files) {
      const fileObj = event.target.files[0];
      ExcelRenderer(fileObj, (err, resp) => {
        if (err) {
          sweetAlert({ title: "Operation Failure", text: err, icon: "error" });
        } else {
          const rows = resp.rows;
          const tickets = [];
          const keys = rows.shift(); //keys,header

          rows.forEach((elm) => {
            if (elm && elm.length) {
              const _ticket = {};
              elm.forEach((item, index) => {
                _ticket[keys[index]] = item;
              });
              keys.forEach((key) => {
                if (_ticket[key] === undefined) {
                  _ticket[key] = "";
                }
              });

              tickets.push(_ticket);
            }
          });
          setReplenishmentSites(tickets);
          field.onChange(tickets);
        }
      });
    } else {
      sweetAlert({
        title: "File Upload Failed",
        text: "Can Not Upload File",
        icon: "error",
      });
    }
  };
  return (
    <>
      {uploadingReplenishmentSite ? <Loader /> : <></>}

      <Card className="mt-4 overflow-hidden w-full">
        <CardHeader>
          <CardTitle>
            <div className="flex flex-row justify-between gap-2 w-full">
              Upload Under Replenishment Site
              <Button
                variant="secondary"
                onClick={replenishmentSitesForm.handleSubmit(
                  onSaveUploadReplenishmentSite
                )}
              >
                Save
              </Button>
            </div>
          </CardTitle>
        </CardHeader>
        <Form {...replenishmentSitesForm}>
          <form className="space-y-8 custom-form-v2">
            <CardContent className="w-full flex flex-row items-center justify-between flex-wrap gap-4">
              <div className="form-row-d-50 [&>.space-y-2]:!w-full">
                <FormField
                  control={replenishmentSitesForm.control}
                  name="serviceDate"
                  rules={{ required: "Please Select Date" }}
                  render={({ field }) => (
                    <FormItem>
                      <Label label="Service Date" isRequired />
                      <FormControl>
                        <div
                          className={
                            replenishmentSitesForm.formState?.errors
                              ?.serviceDate
                              ? "form-date-picker border-red-500 "
                              : "form-date-picker border-secondary"
                          }
                        >
                          <DatePicker
                            variant="secondary"
                            selectedDate={field.value}
                            placeholder="Select Date"
                            onSelectDate={field.onChange}
                            mode="single"
                            disabled={{ before: new Date() }}
                          />
                          {replenishmentSitesForm.formState?.errors
                            ?.serviceDate ? (
                            <p className="text-destructive text-xs">
                              Please Select Date
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </FormControl>
                    </FormItem>
                  )}
                />
                <div style={{ width: "100%" }} />
                <FormField
                  control={replenishmentSitesForm.control}
                  name="file"
                  rules={{ required: "Please Upload File" }}
                  render={({ field }) => (
                    <FormItem>
                      <Label label="Upload File" isRequired />
                      <FormControl>
                        <div>
                          <Input
                            style={
                              replenishmentSitesForm.formState?.errors?.file
                                ? { borderColor: "red" }
                                : {}
                            }
                            type="file"
                            onChange={(event) => {
                              uploadReplenishmentSiteFileHandler(event, field);
                            }}
                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                          />
                          {replenishmentSitesForm.formState?.errors?.file ? (
                            <p className="text-destructive text-xs">
                              Please Upload File
                            </p>
                          ) : (
                            <></>
                          )}
                        </div>
                      </FormControl>
                    </FormItem>
                  )}
                />
              </div>

              {replenishmentSites.length > 0 ? (
                <Grid data={replenishmentSites} className="list-tables-v1">
                  <GridColumn title="Asset Id " field="AssetId" />
                  <GridColumn
                    title="Under Replenishment"
                    field="UnderReplenishment"
                  />
                </Grid>
              ) : (
                <></>
              )}
            </CardContent>
          </form>
        </Form>
      </Card>
    </>
  );
}
